import { promotionCodeFormStyles as styles } from "@waytek/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

styles.form = {
    ...styles.form,
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    `,
};

styles.promotionCodeTextField = {
    ...styles.promotionCodeTextField,
    mergeCss: true,
    labelProps: {
        ...styles.promotionCodeTextField?.labelProps,
        size: "16px",
        lineHeight: "24px",
        weight: 700,
        css: css`
            ${styles.promotionCodeTextField?.labelProps?.css}
            margin-bottom: 0;
        `,
    },
    hintProps: {
        ...styles.promotionCodeTextField?.hintProps,
        css: css`
            ${styles.promotionCodeTextField?.hintProps?.css}
            margin-top: 6px;
        `,
    },
};

styles.applyButton = {
    ...styles.applyButton,
    mergeCss: true,
    variant: "primary",
    css: css`
        ${styles.promotionCodeTextField?.css}
        width: 86px;
        padding-left: 0;
        padding-right: 0;
    `,
};

styles.applyPromotionGridItem = {
    ...styles.applyPromotionGridItem,
    css: css`
        ${styles.applyPromotionGridItem?.css}
        align-items: flex-end;
    `,
};

styles.removeCodeTag = {};
